export default {
  title: "Berechnungsverlauf",
  type: "Typ",
  routeSearch: "Routensuche",
  batchId: "Batch-ID",
  createdAt: "Erstellt am",
  totalDistance: "Gesamtstrecke (km)",
  productionEmission: "Produktions-Emission (kg CO2e)",
  transportEmission: "Transport-Emission (kg CO2e)",
  totalEmission: "Gesamt-Emission (kg CO2e)",
  taxInEUR: "Steuer (€)",
  action: "Aktion",
  detail: "Detail",
  deleteConfirm: "Sind Sie sicher, dass Sie diesen Datensatz löschen möchten?",
  data: "Daten",
  reports: "Berichte",
  batchDownload: "Batch-Download",
  batchDownloadPdf: "PDF-Batch-Download",
  batchDownloadExcel: "Excel-Batch-Download",
  selectPlaceholder: "Bitte wählen Sie mindestens einen Datensatz aus",
  quotaInsufficient: "Unzureichendes Kontingent, bitte upgraden oder kaufen",
  batchDownloadSuccess: "Batch-Download abgeschlossen, Auswahl zurückgesetzt",
  batchDownloadFailed: "Batch-Download fehlgeschlagen",
  emptyFile: "Generierte Datei ist leer",
  downloadProgress: "Download-Fortschritt",
  completed: "abgeschlossen",
  but: "aber",
  regenerate: "Neu generieren",
};
